export enum PriorityType {
  None,
  Low,
  Medium,
  High,
  Emergency,
  PriorityExtra1,
  PriorityExtra2,
  PriorityExtra3,
  PriorityExtra4,
  PriorityExtra5,
  PriorityExtra6,
  PriorityExtra7,
  PriorityExtra8,
  PriorityExtra9,
  PriorityExtra10,
}
